import {Alert} from "antd";
import {useCan} from "~/hooks";

/**
 * Cảnh báo "chưa cấu hình khoá AI" theo VAI TRÒ người xem:
 *  - Admin (cap member_manage / root): chỉ dẫn kỹ thuật (AI_API_KEY, provider, nơi lấy khoá).
 *  - User thường: thông điệp thân thiện "liên hệ quản trị viên" — họ không sửa được .env.
 * Trường hợp gói bắt buộc khoá riêng (require_own_key) giữ nguyên thông điệp cho mọi vai trò.
 */
function AiKeyAlert({configured, requireOwnKey, provider, style}) {

	const isAdmin = useCan('member_manage');

	if (configured) return null;

	let message;
	let description;

	if (requireOwnKey) {
		message = 'Cần khoá AI riêng';
		description = 'Gói của bạn yêu cầu sử dụng khoá AI riêng (không dùng khoá chung của hệ thống). '
			+ 'Vui lòng liên hệ quản trị viên để được cấu hình khoá AI cho tài khoản.';
	} else if (isAdmin) {
		message = 'Chưa cấu hình khoá AI';
		description = `Thêm AI_API_KEY vào backend/.env (nhà cung cấp hiện tại: ${provider || 'gemini'}) để bật chức năng này. `
			+ 'Với Gemini, lấy khoá miễn phí tại aistudio.google.com.';
	} else {
		message = 'Chức năng AI chưa sẵn sàng';
		description = 'Hệ thống chưa được cấu hình AI. Vui lòng liên hệ quản trị viên để kích hoạt.';
	}

	return <Alert type="warning" showIcon style={style} message={message} description={description} />;
}

export default AiKeyAlert;
